// Test IDs for the home / landing feature. Naming follows the directive
// in ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const HOME = {
  emergentLink: 'home-emergent-link',
  
  // Navigation
  navFeatures: 'nav-features',
  navEstimator: 'nav-estimator',
  navAssessment: 'nav-assessment',
  navCaseStudies: 'nav-case-studies',
  caseStudyCard: 'case-study-card',
  navAdmin: 'nav-admin',
  
  // Hero
  heroTitle: 'hero-title',
  heroCta: 'hero-cta-btn',
  
  // Estimator
  estimatorMarketplaceSelect: 'estimator-marketplace-select',
  estimatorSalesSlider: 'estimator-sales-slider',
  estimatorMarginSlider: 'estimator-margin-slider',
  estimatorCalculateBtn: 'estimator-calculate-btn',
  estimatorProjectionDisplay: 'estimator-projection-display',
  
  // Assessment
  assessmentStep: 'assessment-step',
  assessmentNextBtn: 'assessment-next-btn',
  assessmentPrevBtn: 'assessment-prev-btn',
  assessmentOption: 'assessment-option',
  
  // Lead Form
  leadNameInput: 'lead-name-input',
  leadBusinessInput: 'lead-business-input',
  leadEmailInput: 'lead-email-input',
  leadPhoneInput: 'lead-phone-input',
  leadMessageInput: 'lead-message-input',
  leadSubmitBtn: 'lead-submit-btn',
  leadSuccessAlert: 'lead-success-alert',
  
  // Admin Dashboard
  adminMetricLeads: 'admin-metric-leads',
  adminMetricPending: 'admin-metric-pending',
  adminMetricContacted: 'admin-metric-contacted',
  adminLeadRow: 'admin-lead-row',
  adminLeadStatusSelect: 'admin-lead-status-select',
  adminLeadDeleteBtn: 'admin-lead-delete-btn',
  
  // Case Studies Manager
  adminCsClientInput: 'admin-cs-client-input',
  adminCsMarketplaceSelect: 'admin-cs-marketplace-select',
  adminCsGrowthInput: 'admin-cs-growth-input',
  adminCsRevenueBeforeInput: 'admin-cs-revenue-before-input',
  adminCsRevenueAfterInput: 'admin-cs-revenue-after-input',
  adminCsChallengeInput: 'admin-cs-challenge-input',
  adminCsSolutionInput: 'admin-cs-solution-input',
  adminCsSubmitBtn: 'admin-cs-submit-btn',
  adminCsRow: 'admin-cs-row',
  adminCsDeleteBtn: 'admin-cs-delete-btn'
};
